export default __webpack_public_path__ + "static/media/vuesax-linear-task-square.f14934b4.svg";